var $501df0ce1a709e1f$exports = {};
$501df0ce1a709e1f$exports = {
    "breadcrumbs": `Navigasjonsstier`
};


export {$501df0ce1a709e1f$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
